import { animate, style, transition, trigger } from "@angular/animations";
import { Component, inject } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { MatomoTracker } from "ngx-matomo-client";

@Component({
    selector: "app-referrer",
    imports: [],
    templateUrl: "./app-referrer.html",
    styleUrl: "./app-referrer.scss",
    animations: [
        trigger("slideAnimation", [
            transition(":enter", [style({ transform: "translateY(100%)" }), animate("400ms ease-out")]),
            transition(":leave", [animate("400ms ease-in", style({ transform: "translateY(100%)" }))])
        ])
    ]
})
export class AppReferrer {
    public isVisible: boolean = true;
    public isMobile: boolean = false;
    public isNativeApp: boolean = false;
    private readonly matomoTracker = inject(MatomoTracker);

    ngOnInit() {
        this.detectPlatform();
    }

    private detectPlatform() {
        if (Capacitor?.isNativePlatform()) {
            this.isNativeApp = true;
            this.isMobile = true;
        } else {
            this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            this.isNativeApp = false;
        }
    }

    close() {
        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        this.matomoTracker.trackEvent("Forside app banner", "Luk", isAndroid ? "Android" : isIOS ? "iOS" : "Ukendt platform");
        this.isVisible = false;
    }

    openApp() {
        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (isAndroid) {
            this.matomoTracker.trackEvent("Forside app banner", "Installer", "Android");

            // Vi sætter en timeout for at sikre Matomo event bliver sendt før redirect
            setTimeout(() => {
                window.location.href = "https://play.google.com/store/apps/details?id=dk.dffedb.eforsyning";
            }, 500);

            setTimeout(function () {
                window.location.href = "https://play.google.com/store/apps/details?id=dk.dffedb.eforsyning";
            }, 2000);
        } else if (isIOS) {
            this.matomoTracker.trackEvent("Forside app banner", "Installer", "iOS");

            setTimeout(() => {
                window.location.href = "itms-apps://apps.apple.com/dk/app/e-forsyning/id694578367";
            }, 500);

            setTimeout(function () {
                window.location.href = "https://apps.apple.com/dk/app/e-forsyning/id694578367";
            }, 1500);
        }
    }

    // TODO: Try to make this work some day with deep linking to the app
    // openApp() {
    //     const isAndroid = /Android/i.test(navigator.userAgent);
    //     const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    //     if (isAndroid) {
    //         window.location.href = "https://dev-eforsyning.softvaerket.dk/app/open";

    //         const timeout = setTimeout(() => {
    //             window.location.href = "https://play.google.com/store/apps/details?id=dk.dffedb.eforsyning";
    //         }, 1500);

    //         window.addEventListener("pagehide", () => clearTimeout(timeout), { once: true });
    //     } else if (isIOS) {
    //         window.location.href = "https://dev-eforsyning.softvaerket.dk/app/open";

    //         const timeout = setTimeout(() => {
    //             window.location.href = "https://apps.apple.com/dk/app/e-forsyning/id694578367";
    //         }, 1500);

    //         window.addEventListener("pagehide", () => clearTimeout(timeout), { once: true });
    //     }
    // }
}
